import React from "react";

const Authenticating = ({ children, role, msalInstance }) => {
  return (
    <div
      className="access-denied"
      style={{
        textAlign: "center",
        marginTop: "50px",
        backgroundColor: "white",
        maxWidth: "500px",
        width: "fit-content",
        margin: "50px auto",
        padding: "30px 50px",
        borderRadius: "5px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
      }}>
      <h1>Authenticating user...</h1>
    </div>
  )
};

export default Authenticating;
